
import filters from "~/mixins/filters";
import {mapActions, mapGetters} from "vuex";

export default {
	data() {
		return {
			carInfoSwiper: null,
			activeTab: 1,
			gearbox: {
				'mechanical': 'МКПП',
				'cvt': 'Вариатор',
				'robot': 'Робот',
				'automatic': 'АКПП',
			}
		}
	},
	mixins: [filters],
	computed: {
		...mapGetters({
			offer: 'catalog/catalog-cars/offer'
		}),
		tabs() {
			let tabs = [
				{
					title: 'Характеристики',
					id: 'tab-1',
					showButton: true
				},
				{
					title: 'Комплектация',
					id: 'tab-2',
					showButton: !!this.equipment_group_list.length
				},
				{
					title: 'Условия кредита',
					id: 'tab-3',
					showButton: !!this.equipment_group_list.length
				}
			]
			return tabs.filter(item => item.showButton)
		},
		currentGerabox() {
			// return this.gearbox[this.offer.gearbox.name] || this.offer.gearbox.title
			return this.offer.gearbox.title_short_rus
		},
		equipment_group_list() {
			return this.offer.equipment_groups
		},


		showTech() {
			if (this.$device.isMobile) {
				return this.activeTab === 1
			} else {
				return true
			}
		},
		showComplectation() {
			if (this.$device.isMobile) {
				return this.activeTab === 2
			} else {
				return true
			}
		},
		showBenefits() {
			if (this.$device.isMobile) {
				return this.activeTab === 3
			} else {
				return true
			}
		}
	},
	methods: {
		...mapActions({
			openModal: 'modal/modal-main/openModal',
			request: 'request'
		}),
		// scrollTo(el) {
		// 	const elLeft = el.offsetLeft + el.offsetWidth;
		// 	const elParentLeft = el.parentNode.offsetLeft + el.parentNode.offsetWidth;
		// 	// check if element not in view
		// 	if (elLeft >= elParentLeft + el.parentNode.scrollLeft) {
		// 		el.parentNode.scrollLeft = elLeft - elParentLeft;
		// 	} else {
		// 		el.parentNode.scrollLeft = 0;
		// 	}
		// },
		changeTab(tab) {
			this.activeTab = tab + 1
		},
		async tabClick(tab) {
			this.activeTab = tab
			// await this.carInfoSwiper.slideTo(tab - 1)
		},
		async moreInfoComplectation(carInfo) {
			let payload = {
				modal_data: carInfo,
				modal_component: 'modal-complect',
				modal_title: 'Комплектация',
				modal_sub_title: carInfo.name
			}
			await this.openModal(payload)
		},
	},
	// mounted() {
	// 	if (this.$device.isMobile) {
	// 		this.carInfoSwiper = new swiper.default('.swiper--car-info.swiper', {
	// 			modules: [swiper.Navigation, swiper.Pagination, swiper.Autoplay],
	// 			autoplayDisableOnInteraction: false,
	// 			autoplay: false,
	// 			autoHeight: true,
	// 			on: {
	// 				slideChange: (event) => {
	// 					this.changeTab(event.activeIndex)
	// 					this.$scrollTo(`#tab-${this.activeTab}`, 500, {
	// 						container: ".tabs__list",
	// 						x: true,
	// 						offset: -16,
	// 						y: false
	// 					})
	// 				}
	// 			},
	// 			spaceBetween: 24,
	// 			pagination: {
	// 				el: '.car__info .swiper-pagination',
	// 				type: 'bullets',
	// 			},
	// 		})
	// 	}
	// }
}
